import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../domain/app-settings';

export const initializeApp = (
  http: HttpClient
) => {
  return () =>
    http.get('./assets/settings.json').toPromise()
    .then((res) => {
      console.log("config file fetched correctly")
      AppSettings.configuration = res;
      return res;
    })
    .catch((err) => {
      console.log("error during config fetch")
      return err;
    });
};
